import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';
import { getSite } from '../config/sites';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

const { databaseId: firestoreDatabaseId } = getSite();
const functionsRegion = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1';

export const db = getFirestore(app, firestoreDatabaseId);
export const functions = getFunctions(app, functionsRegion);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
// Web push VAPID public key (Firebase Console → Project settings → Cloud Messaging).
export const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';
